function createSliderFromBanners() {
  var middleBanners = $(".next-to-carousel-banners");

  var middleBanner = middleBanners.find(".banner-wrapper");

  middleBanner.wrap('<div class="swiper-slide"></div>');

  middleBanners.wrapInner(
    '<div class="swiper-container js-slider-middle-banners"></div>'
  );

  middleBanners
    .find(".swiper-container")
    .wrapInner('<div class="swiper-wrapper"></div>');

  middleBanners.wrapInner(
    '<div class="js-slider-group slider-group-middle-banners"></div>'
  );

  var paginationTemplate =
    '<div class="swiper-pagination js-swiper-pagination"></div>';

  middleBanners.find(".slider-group-middle-banners").append(paginationTemplate);

  var arrowTemplate =
    '<div class="swiper-arrow swiper-arrow-next js-swiper-arrow-next">' +
    '<div class="swiper-arrow-content">' +
    '<span class="icon-svg icon-chevron-right"></span>' +
    "</div>" +
    "</div>" +
    '<div class="swiper-arrow swiper-arrow-prev js-swiper-arrow-prev">' +
    '<div class="swiper-arrow-content">' +
    '<span class="icon-svg icon-chevron-left"></span>' +
    "</div>" +
    "</div>";
  middleBanners.find(".slider-group-middle-banners").append(arrowTemplate);

  middleBannersSlider();
}

function middleBannersSlider() {
  if ($(".js-slider-middle-banners").length) {
    $(".js-slider-middle-banners").each(function () {
      var inst = $(this),
        swiperBlock = inst.closest(".js-slider-group"),
        swiperPagination = swiperBlock.find(".js-swiper-pagination"),
        swiperArrowPrev = swiperBlock.find(".js-swiper-arrow-prev"),
        swiperArrowNext = swiperBlock.find(".js-swiper-arrow-next");

      var mySwiper = new Swiper(inst, {
        spaceBetween: 30,
        lazy: true,
        loop: true,
        speed: 600,
        // autoplay: {
        //   delay: 4000,
        //   disableOnInteraction: true,
        // },
        navigation: {
          nextEl: swiperArrowNext,
          prevEl: swiperArrowPrev,
        },
        pagination: {
          el: swiperPagination,
          clickable: true,
        },
        breakpoints: {
          200: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 1,
          },
          992: {
            slidesPerView: 1,
          },
          1200: {
            slidesPerView: 1,
          },
        },
      });
    });
  }
}
